import { formatCurrency } from "@src/utils/currencyFormatter";
import styles from "./MultipleValidityCardListing.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAwsAssets } from "@src/utils";
import { t } from "i18next";
import { useState } from "react";
import { useRouter } from "@src/lib/router";
import { applyCourseCouponAction, setCouponCodeAction } from "../../../store/actions";
function MultipleValidityCardListing({data,handleSelectedData=()=>{}}) {
    const router = useRouter();
    const promotedValidity = useSelector(
        (state) => state.overviewReducer.promotedValidity
      );
    const [selectedValidity, setSelectedvalidity] = useState(promotedValidity);
    const dispatch = useDispatch();
    const countryCode = useSelector(
        (state) =>
          state?.persistedDataReducer?.orgDetails?.organization?.countryCode
      );
      const appliedCoupon = useSelector(
        (state) => state?.overviewReducer?.graphCourseData?.appliedCoupon
      );

      const onChangeHandler = (validityData) => {
        if (appliedCoupon) {
          dispatch(
            applyCourseCouponAction(
              {
                variables: {
                  courseId: router.query.courseId,
                  code: appliedCoupon?.code,
                  ocvmId: validityData?.id,
                },
              },
              true
            )
          );
          dispatch(
            setCouponCodeAction({
              coupon: {
                code: appliedCoupon?.code,
              },
            })
          );
        }
        handleSelectedData(validityData);
        setSelectedvalidity((prevState) => {
          // if (prevState?.id === validityData?.id) {
          //   return;
          // } else {
          //   return validityData;
          // }
          return validityData;
        });
      };
    return (
        <>
        {data?.map((validity) => (
              <div
                className={`${styles.validityCardWrapper} ${
                  selectedValidity?.id === validity.id
                    ? styles.selectedValidityCardWrapper
                    : styles.unselectedValidityCardWrapper
                }
              `}
                onClick={() => onChangeHandler(validity)}
                key={validity.id}
              >
                <div className={styles.validityCardPriceWrapper}>
                  <div className={styles.validityTitlewrapper}>
                    {selectedValidity?.id === validity?.id ? (
                      <img
                        src={getAwsAssets("blueTick.svg", "layout")}
                        alt=""
                        className={styles.image}
                      />
                    ) : (
                      <input
                        className={styles.radioButton}
                        type="radio"
                        checked={selectedValidity?.id === validity?.id}
                      />
                    )}
                    <div className={styles.validityHeading}>
                      {validity.title}
                    </div>
                  </div>
                  <div className={styles.discountWrapper}>
                    {validity.discount > 0 && (
                      <div className={styles.validityDiscount}>
                        {validity.discountPercentageText}
                      </div>
                    )}
                    <div className={styles.validityHeading}>
                      {formatCurrency(countryCode, validity.finalPrice)}
                    </div>
                  </div>
                </div>
                {validity.discount > 0 && (
                  <div className={styles.validityCardFinalPriceWrapper} style={{justifyContent:validity.isPromoted === 1 ? "space-between" : "flex-end"}}>
                    {validity?.isPromoted === 1 ? <p className={styles.recomendCard}>RECOMMENDED</p> : null}
                    <span style={{ textDecoration: "line-through" }}>{formatCurrency(countryCode, validity.price)}</span>
                  </div>
                )}
              </div>
            ))}
            {selectedValidity?.id &&
              (countryCode === "KR" ? (
                <div className={styles.selectedValidityText}>{`${
                  selectedValidity.title
                }  ${t(
                  "components.tabs.overview.components.multipleValidity.multipleValidityModal.selectedCourseText",
                  "You will be able to access this course for"
                )}`}</div>
              ) : (
                <div className={styles.selectedValidityText}>{`${t(
                  "components.tabs.overview.components.multipleValidity.multipleValidityModal.selectedCourseText",
                  "You will be able to access this course for"
                )} ${selectedValidity.title} `}</div>
              ))}
        </>
    )
}

export default MultipleValidityCardListing;